import { Button } from "@heroui/react";

const LoginRequired = ({
  title = "Login Required",
  description,
  onLogin,
  onSignup
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4">
      <div className="w-20 h-20 mb-6 rounded-full bg-gray-100 flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-10 w-10 text-gray-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>

      <h2 className="text-2xl font-bold text-gray-800 mb-3">{title}</h2>

      <p className="text-gray-600 text-center max-w-md mb-8">{description}</p>

      <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4">
        <Button
          className="bg-yellowbuy border border-black rounded-lg font-medium px-6 py-2"
          onPress={onLogin}
        >
          Login to Your Account
        </Button>

        <Button
          className="bg-white border border-gray-300 rounded-lg font-medium px-6 py-2"
          onPress={onSignup}
        >
          Create Account
        </Button>
      </div>
    </div>
  );
};

export default LoginRequired;
